import { get, isEmpty } from "lodash";

const SUPPORTED_CLIENT_TYPES = ["individual", "organization", "serviceobject", "contactPerson", "partner"];

const PHONE_KEYS = ["homePhone", "workPhone"];
const loggedErrors = {};

const CUSTOMER_LAST_NAME = "lastName";
const CUSTOMER_FIRST_NAME = "firstName";
const CUSTOMER_PANTRONYMIC = "patronymic";
const CUSTOMER_MULTI_EDIT_FIELDS = [CUSTOMER_LAST_NAME, CUSTOMER_FIRST_NAME, CUSTOMER_PANTRONYMIC];

const getStaticWidget = (widgetName, client, handleContactChange, clientType, customerId, t, staticBlocks) => {
    if (widgetName === "name") {
        return getNameWidgets({ client, handleContactChange, clientType, customerId, t, staticBlocks });
    }
    if (PHONE_KEYS.includes(widgetName)) {
        return getHomePhoneWidget({
            client,
            handleContactChange,
            clientType,
            customerId,
            t,
            staticBlocks,
        });
    }
    if (widgetName === "email") {
        return getEmailWidget({ client, handleContactChange, clientType, customerId, t, staticBlocks });
    }
    if (widgetName === "address") {
        return getAddressWidget({
            client,
            handleContactChange,
            clientType,
            customerId,
            t,
            staticBlocks,
        });
    }
    if (widgetName === "issues") {
        return getIssuesWidget({
            client,
            clientType,
            customerId,
            t,
            staticBlocks,
        });
    }
};

// handle staticData
const getStaticExtendData = (staticBlocks, clientType, type, fieldName) => {
    const staticFormOrigin =
        (staticBlocks &&
            staticBlocks.origin &&
            staticBlocks.origin[`left_panel_customer_${clientType.toLowerCase()}_form_new`]) ||
        {};
    const staticFormDefault =
        (staticBlocks &&
            staticBlocks.default &&
            staticBlocks.default[`left_panel_customer_${clientType.toLowerCase()}_form_new`]) ||
        {};
    const staticFormStaticUI =
        (staticBlocks &&
            staticBlocks.defaultStaticUI &&
            staticBlocks.defaultStaticUI[`left_panel_customer_${clientType.toLowerCase()}_form_new`]) ||
        {};

    const isNoOriginConfig = !staticFormOrigin || isEmpty(staticFormOrigin);
    const isNoDefaultConfig = !staticFormDefault || isEmpty(staticFormDefault);
    const logKey = `left_panel_customer_${clientType.toLowerCase()}_form_new_${type}`;
    let staticBlock;
    // no origin and default - fallback to UI
    if (isNoOriginConfig && isNoDefaultConfig) {
        staticBlock = get(staticFormStaticUI, `blocks.${type}`);
        if (!loggedErrors[logKey]) {
            console.info(
                `⚠️ getStaticExtendData::${type}: Static blocks are not configured correctly (no FORM and FORM_DEFAULT for [left_panel_customer_${clientType.toLowerCase()}_form_new: ${type}], using STATIC UI FALLBACK)`
            );
            loggedErrors[logKey] = true;
        }
        // try to set origin first (FORM), if not available => FORM_DEFAULT
    } else {
        staticBlock = get(staticFormOrigin, `blocks.${type}`);
        if (!staticBlock || isEmpty(staticBlock)) {
            if (!loggedErrors[`${logKey}_default`]) {
                console.info(
                    `⚠️ getStaticExtendData::${type}: FORM blocks are not configured, trying to fallback to FORM_DEFAULT for [left_panel_customer_${clientType.toLowerCase()}_form_new: ${type}]`
                );
                loggedErrors[`${logKey}_default`] = true;
            }
            staticBlock = get(staticFormDefault, `blocks.${type}`);
        }
    }

    // console.log({[type]: staticBlock});

    const staticAttr =
        staticBlock && staticBlock.sortedAttrs ? staticBlock.sortedAttrs.find(item => item.field === fieldName) : null;

    const staticExtendData = {};

    if (staticAttr) {
        staticExtendData.isReq = staticAttr.required;
        staticExtendData.isHidden = staticBlock.hidden || staticAttr.hidden;
        staticExtendData.isHiddenByConfig = staticBlock.hidden || staticAttr.hidden;
        staticExtendData.hiddenValues = staticAttr.hiddenValues;
        staticExtendData.order = staticAttr.order;
    }

    // block is not provided - hide widget
    if (!staticAttr) {
        staticExtendData.isHidden = true;
        staticExtendData.isHiddenByConfig = true;
    }

    // if (fieldName === "lastName") {
    //     console.log({staticBlock, staticAttr, staticExtendData});
    // }

    return staticExtendData;
};

const convertDictionaryObject = dictionaryObject =>
    Object.entries(dictionaryObject).map(([prop, value]) => ({
        key: prop,
        value: value,
    }));

export const CONTACT_CONFIG = {
    homePhone: {
        widgetType: "contact",
        field: "contacts.homePhone",
        // field: 'homePhone',
        // required: true,
        key: "homePhone",
        type: "homePhone",
    },
    workPhone: {
        widgetType: "contact",
        field: "workPhone",
        // required: true,
        key: "workPhone",
        type: "workPhone",
    },
    email: { widgetType: "contact", field: "contacts.email", key: "email", type: "email" },
};

// prepare names widgets
const multiNames = ["contactPerson", "individual"];
const getNameWidget = ({ t, client, clientType, field }) => {
    const isReq = ["officialName", CUSTOMER_FIRST_NAME].includes(field);
    let liveSaveUrlKey = "customer_edit";
    if (clientType === "contactPerson") {
        liveSaveUrlKey = "person_edit_multi";
    }
    if (clientType === "individual") {
        liveSaveUrlKey = "customer_edit_multi";
    }
    return {
        title: t(`customerInfoLabel.${field}`),
        key: field,
        isReq,
        savedValue: get(client, `party.${field}`) || null,
        widgetType: "input",
        customLiveSubmit: (data, bindedValues) => {
            const { attrValue, attrCode } = data.data;
            const newData = {
                ...data,
                data: {
                    personId: clientType === "contactPerson" ? client.id : null,
                    customerId: clientType !== "contactPerson" ? client.id : null,
                },
            };
            const isMulti = multiNames.includes(clientType);
            if (!isMulti) {
                newData.data = {
                    ...newData.data,
                    text: attrValue,
                    field: `party.${attrCode}`,
                };
            }
            if (isMulti) {
                const convertedMultiValues = Object.keys(bindedValues).map(key => ({
                    text: bindedValues[key],
                    field: `party.${key}`,
                }));
                // old single field method
                // newData.data.edit = [
                //     {
                //         text: attrValue,
                //         field: `party.${attrCode}`,
                //     },
                // ];
                // new multi fields method
                newData.data.edit = convertedMultiValues;
            }
            return { data: newData, liveSaveUrlKey };
        },
    };
};
export const getNameWidgets = ({ client, clientType, t, staticBlocks }) => {
    // return miltinames widgets;
    // console.log({client, clientType, t, staticBlocks});
    if (multiNames.includes(clientType)) {
        return [
            {
                bindedValuesKeys: CUSTOMER_MULTI_EDIT_FIELDS,
                ...getNameWidget({
                    t,
                    client,
                    clientType,
                    field: CUSTOMER_LAST_NAME,
                }),
                ...getStaticExtendData(staticBlocks, clientType, "nameData", CUSTOMER_LAST_NAME),
            },
            {
                bindedValuesKeys: CUSTOMER_MULTI_EDIT_FIELDS,
                ...getNameWidget({
                    t,
                    client,
                    clientType,
                    field: CUSTOMER_FIRST_NAME,
                }),
                ...getStaticExtendData(staticBlocks, clientType, "nameData", CUSTOMER_FIRST_NAME),
            },
            {
                bindedValuesKeys: CUSTOMER_MULTI_EDIT_FIELDS,
                ...getNameWidget({
                    t,
                    client,
                    clientType,
                    field: CUSTOMER_PANTRONYMIC,
                }),
                ...getStaticExtendData(staticBlocks, clientType, "nameData", CUSTOMER_PANTRONYMIC),
            },
        ].sort((a, b) => a.order - b.order);
    }
    // return singlename widget
    return [
        {
            ...getNameWidget({
                t,
                client,
                clientType,
                field: "officialName",
            }),
            ...getStaticExtendData(staticBlocks, clientType, "nameData", "name"),
        },
    ];
};

// prepare custom widgets
export const getHomePhoneWidget = ({ client, handleContactChange, clientType, t, staticBlocks }) => {
    const phoneType = clientType === "contactPerson" ? "workPhone" : "homePhone";
    // prepare phoneWidget
    const phoneWidget = {
        ...CONTACT_CONFIG[phoneType],
        title: t("customerInfoLabel.homePhone"),
        savedValue: null,
        widgetType: "contact",
        handleContactChange,
        ...getStaticExtendData(staticBlocks, clientType, "phoneData", phoneType),
    };
    // console.log({phoneWidget});
    let contacts = [];
    if (clientType === "contactPerson") {
        contacts = get(client, "contacts").filter(contact => contact.type === "workPhone");
    } else {
        contacts = get(client, "contacts.homePhone");
    }
    if (contacts.length === 0) {
        contacts = [{ value: "", id: 0 }];
    }
    // console.log({ phones: contacts });
    phoneWidget.savedValue = contacts;
    return phoneWidget;
};

export const getEmailWidget = ({ client, handleContactChange, clientType, t, staticBlocks }) => {
    // prepare emailWidget
    const emailWidget = {
        ...CONTACT_CONFIG.email,
        title: t("customerInfoLabel.email"),
        key: "email",
        savedValue: null,
        widgetType: "contact",
        handleContactChange,
        ...getStaticExtendData(staticBlocks, clientType, "emailData", "email"),
    };
    let contacts = [];
    if (clientType === "contactPerson") {
        contacts = get(client, "contacts").filter(contact => contact.type === "email");
    } else {
        contacts = get(client, "contacts.email");
    }
    if (contacts.length === 0) {
        contacts = [{ value: "", id: 0 }];
    }
    // console.log({ email: contacts });
    emailWidget.savedValue = contacts;
    // console.log({ emails: contacts });
    return emailWidget;
};

export const getAddressWidget = ({ client, t, clientType, staticBlocks }) => {
    const type = "addressData";
    const staticFormOrigin = staticBlocks.origin[`left_panel_customer_${clientType.toLowerCase()}_form_new`] || {};
    const staticFormDefault = staticBlocks.default[`left_panel_customer_${clientType.toLowerCase()}_form_new`] || {};
    const staticFormStaticUI =
        staticBlocks.defaultStaticUI[`left_panel_customer_${clientType.toLowerCase()}_form_new`] || {};

    const isNoOriginConfig = !staticFormOrigin || isEmpty(staticFormOrigin);
    const isNoDefaultConfig = !staticFormDefault || isEmpty(staticFormDefault);
    const logKey = `left_panel_customer_${clientType.toLowerCase()}_form_new_${type}`;
    let staticBlock;
    // no origin and default - fallback to UI
    if (isNoOriginConfig && isNoDefaultConfig) {
        staticBlock = get(staticFormStaticUI, `blocks.${type}`);
        if (!loggedErrors[logKey]) {
            console.info(
                `⚠️ getAddressWidget::${type}: Static blocks are not configured correctly (no FORM and FORM_DEFAULT for [left_panel_customer_${clientType.toLowerCase()}_form_new: ${type}], using STATIC UI FALLBACK)`
            );
            loggedErrors[logKey] = true;
        }
        // try to set origin first (FORM), if not available => FORM_DEFAULT
    } else {
        staticBlock = get(staticFormOrigin, `blocks.${type}`);
        if (!staticBlock || isEmpty(staticBlock)) {
            if (!loggedErrors[`${logKey}_default`]) {
                console.info(
                    `⚠️ getAddressWidget::${type}: FORM blocks are not configured, trying to fallback to FORM_DEFAULT for [left_panel_customer_${clientType.toLowerCase()}_form_new: ${type}]`
                );
                loggedErrors[`${logKey}_default`] = true;
            }
            staticBlock = get(staticFormDefault, `blocks.${type}`);
        }
    }
    // console.log({addressBlock: staticBlock });
    // const staticBlock = staticForm.blocks && staticForm.blocks.custAddress;
    // prepare addressWidget
    const addressWidget = {
        title: t("address"),
        key: "primaryAddress",
        savedValue: null,
        widgetType: "address",
        isHidden: !staticBlock || staticBlock.hidden,
        customerId: client.id,
        customerType: clientType,
        isHiddenByConfig: !staticBlock || staticBlock.hidden,
    };

    const address = get(client, "primaryAddress");
    if (address) {
        // console.log({ address });
        const savedValue = address;
        addressWidget.savedValue = savedValue;
    }
    return addressWidget;
};

export const getIssuesWidget = ({ client, clientType, customerId, t, staticBlocks }) => {
    const staticData = getStaticExtendData(staticBlocks, clientType, "issuesData", "issues");
    const values = convertDictionaryObject(t("dictionary:contactIssue", { returnObjects: true }));
    const issuesWidget = {
        title: t("customerInfoLabel.issues"),
        key: "issues",
        isReq: true,
        savedValue: null,
        widgetType: "multiselect",
        values,
        customLiveSubmit: data => {
            const { attrValue: issues, id } = data.data;
            const newData = {
                ...data,
                data: {
                    issues,
                    personId: id,
                    entityid: customerId,
                    entity_type: "CUSTOMER",
                },
            };
            return { data: newData, liveSaveUrlKey: "issues_edit" };
        },
        ...staticData,
    };
    const links = get(client, "links");
    const link = links && links.find(link => +link.entityId === +customerId);
    const issues = get(link, "issues");
    if (issues && issues.length > 0) {
        const savedValues = issues;
        issuesWidget.savedValues = savedValues;
    }
    return issuesWidget;
};

function getCustomerStaticBlocks(clientType, allBlocks) {
    const staticFormOrigin =
        (allBlocks &&
            allBlocks.origin &&
            allBlocks.origin[`left_panel_customer_${clientType.toLowerCase()}_form_new`]) ||
        {};
    const staticFormDefault =
        (allBlocks &&
            allBlocks.default &&
            allBlocks.default[`left_panel_customer_${clientType.toLowerCase()}_form_new`]) ||
        {};
    const staticFormStaticUI =
        (allBlocks &&
            allBlocks.defaultStaticUI &&
            allBlocks.defaultStaticUI[`left_panel_customer_${clientType.toLowerCase()}_form_new`]) ||
        {};

    const isNoOriginConfig = !staticFormOrigin || isEmpty(staticFormOrigin);
    const isNoDefaultConfig = !staticFormDefault || isEmpty(staticFormDefault);
    const logKey = `left_panel_customer_${clientType.toLowerCase()}_form_new`;
    let staticBlocks;
    // no origin and default - fallback to UI
    if (isNoOriginConfig && isNoDefaultConfig) {
        staticBlocks = get(staticFormStaticUI, `blocks`);
        if (!loggedErrors[logKey]) {
            console.info(
                `⚠️ getCustomerStaticBlocks::${clientType}: Static blocks are not configured correctly (no FORM and FORM_DEFAULT for [left_panel_customer_${clientType.toLowerCase()}_form_new, using STATIC UI FALLBACK)`
            );
            loggedErrors[logKey] = true;
        }
        // try to set origin first (FORM), if not available => FORM_DEFAULT
    } else {
        staticBlocks = get(staticFormOrigin, `blocks`);
        if (!staticBlocks || isEmpty(staticBlocks)) {
            if (!loggedErrors[`${logKey}_default`]) {
                console.info(
                    `⚠️ getCustomerStaticBlocks::${clientType}: FORM blocks are not configured, trying to fallback to FORM_DEFAULT for [left_panel_customer_${clientType.toLowerCase()}_form_new`
                );
                loggedErrors[`${logKey}_default`] = true;
            }
            staticBlocks = get(staticFormDefault, `blocks`);
        }
    }
    return staticBlocks;
}

export const getStaticFormBlocks = ({ client, handleContactChange, clientType: initialClientType, customerId, t, staticBlocks }) => {
    const isSupported = SUPPORTED_CLIENT_TYPES.includes(initialClientType);
    let clientType = initialClientType;
    if (!isSupported) {
        clientType = "organization";
    }
    const currentStaticBlocks = getCustomerStaticBlocks(clientType, staticBlocks);
    const arrayBlocks = Object.keys(currentStaticBlocks).map(key => {
        const { attrs, sortedAttrs, ...rest } = currentStaticBlocks[key];
        const blockData = {
            ...rest,
            key,
            widgets: sortedAttrs.map(attr => {
                const widget = getStaticWidget(
                    attr.field,
                    client,
                    handleContactChange,
                    clientType,
                    customerId,
                    t,
                    staticBlocks
                );
                return widget;
            }),
        };

        if (key === "nameData") {
            blockData.widgets = getStaticWidget(
                "name",
                client,
                handleContactChange,
                clientType,
                customerId,
                t,
                staticBlocks
            );
        } else if (key === "addressData") {
            blockData.widgets = [
                getStaticWidget("address", client, handleContactChange, clientType, customerId, t, staticBlocks),
            ];
        } else {
            blockData.widgets = sortedAttrs.map(attr => {
                const widget = getStaticWidget(
                    attr.field,
                    client,
                    handleContactChange,
                    clientType,
                    customerId,
                    t,
                    staticBlocks
                );
                return widget;
            });
        }
        return blockData;
    }, []);
    return arrayBlocks;
};
